import { format } from "date-fns"
import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../../lib/redux/hooks'
import { Calendar } from '../../../../../ui/molecules/calendar'
import { ProtocolSelectByObject } from '../../../../../ui/molecules/ProtocolSelectByObj'
import { CustomRadio } from '../../../../../ui/molecules/radioButton'
import { MadfarmStaticSelect } from '../../../../../ui/molecules/select/newSelect/static'
import { TableSelect } from '../../../../../ui/molecules/tableSelect'
import { MeasureVersionOptions } from '../../../../../utils/measuresUtils'
import { resetGetAllAppliedResponseMeasure, resetNewMeasureUpdateRequest, setMewMeasureCreationM024Id, setNewMeasureCreationCustomerId, setNewMeasureCreationDepartureProtocolId, setNewMeasureCreationIsCodexRealesed, setNewMeasureCreationMeasureDate, setNewMeasureCreationNonComplianceCodeVersion, setNewMeasureCreationOfficerId } from '../../slice'

export enum SelectionFlagEnum {
    NEW_PROTOCOL = 'NEW_PROTOCOL',
    EXISTENT_PROTOCOL = 'EXISTENT_PROTOCOL',
}

export function AddNewCodexMeasureFormsStep1() {
    const dispatch = useAppDispatch()
    const [selectionFlag, setSelectionFlag] = useState<SelectionFlagEnum>(SelectionFlagEnum.NEW_PROTOCOL)
    const sessionState = useAppSelector(state => state.session)
    const newMeasureState = useAppSelector(state => state.newMeasure)
    const userState = useAppSelector(state => state.users)

    useEffect(() => {
        dispatch(setNewMeasureCreationCustomerId(sessionState.selected.customerId))
        dispatch(setNewMeasureCreationOfficerId(userState.findMeResponse.id))
        dispatch(setNewMeasureCreationIsCodexRealesed(true))
        dispatch(resetNewMeasureUpdateRequest())
        dispatch(resetGetAllAppliedResponseMeasure())
        dispatch(setNewMeasureCreationDepartureProtocolId(undefined))
    }, [])

    return (
        <div className="flex flex-col gap-6 p-6">
            <div className="rounded-xl border border-neutral-200 bg-white shadow-sm overflow-hidden">
                <div className="bg-brandPrimary-600 px-6 py-4">
                    <span className="text-white font-semibold text-lg">Provvedimenti </span>
                    <span className="text-brandPrimary-300">/</span>
                    <span className="text-brandPrimary-100 font-semibold"> Modalità di Inserimento</span>
                </div>
                <div className="p-6">
                    <MadfarmStaticSelect
                        placeholder="Seleziona modalità..."
                        value={newMeasureState.newMeasureCreationRequest.nonComplianceCodeVersion}
                        options={MeasureVersionOptions}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            dispatch(setNewMeasureCreationNonComplianceCodeVersion(newValue))
                        }}
                        noOptionsMessage={""}
                    />
                </div>
            </div>
            <div className="rounded-xl border border-neutral-200 bg-white shadow-sm overflow-hidden">
                <div className="bg-brandPrimary-600 px-6 py-4">
                    <span className="text-white font-semibold text-lg">Provvedimenti </span>
                    <span className="text-brandPrimary-300">/</span>
                    <span className="text-brandPrimary-100 font-semibold"> M024 per cui emettere il provvedimento</span>
                </div>
                <div className="p-6">
                    <TableSelect
                        type="radio"
                        onChange={(value) => dispatch(setMewMeasureCreationM024Id(value[0]))}
                        headers={['Revisione M024', 'Data Creazione', 'Data Decisione', 'Funzionario Conformità', 'Funzionario Riesame', 'Stato']}
                        data={[
                            { value: '1', labels: ['Revisione 1', '22/02/2025', '22/02/2025', 'Alessandro Lo Giudice', 'Giovanni Fazio', 'Chiuso'] },
                            { value: '2', labels: ['Revisione 2', '23/02/2025', '23/02/2025', 'Camillo Bonaccorso', null, 'Chiuso'] },
                            { value: '3', labels: ['Revisione 3', '22/02/2025', '22/02/2025', 'Alessandro Lo Giudice', null, 'Aperto'] },
                        ]}
                    />
                </div>
            </div>

            <div className="rounded-xl border border-neutral-200 bg-white shadow-sm overflow-hidden">
                <div className="bg-brandPrimary-600 px-6 py-4">
                    <span className="text-white font-semibold text-lg">Provvedimenti </span>
                    <span className="text-brandPrimary-300">/</span>
                    <span className="text-brandPrimary-100 font-semibold"> Dati di Riepilogo</span>
                </div>
                <div className="p-6 flex flex-col gap-6">
                    <CustomRadio
                        id="protocol-flag-new"
                        name="protocolFlag"
                        selectedValue={selectionFlag}
                        options={[{ label: 'Crea Protocollo per il Provvedimento', value: SelectionFlagEnum.NEW_PROTOCOL }]}
                        onChange={() => {
                            setSelectionFlag(SelectionFlagEnum.NEW_PROTOCOL)
                            dispatch(setNewMeasureCreationDepartureProtocolId(undefined))
                        }}
                    />
                    <div className="ml-7">
                        <Calendar
                            label="Data protocollo"
                            disabled={selectionFlag === SelectionFlagEnum.EXISTENT_PROTOCOL}
                            selected={newMeasureState.newMeasureCreationRequest.measureDate}
                            onChange={(date) => dispatch(setNewMeasureCreationMeasureDate(format(new Date(date), 'yyyy-MM-dd')))}
                        />
                    </div>

                    <div className="border-t border-neutral-200" />
                    <CustomRadio
                        id="protocol-flag-existing"
                        name="protocolFlag"
                        selectedValue={selectionFlag}
                        options={[{ label: 'Scegli Protocollo esistente per il Provvedimento', value: SelectionFlagEnum.EXISTENT_PROTOCOL }]}
                        onChange={() => {
                            setSelectionFlag(SelectionFlagEnum.EXISTENT_PROTOCOL)
                            dispatch(setNewMeasureCreationMeasureDate(undefined))
                        }}
                    />
                    <div className="ml-7">
                        <ProtocolSelectByObject
                            key={newMeasureState.newMeasureCreationRequest.departureProtocolId || 'default'}
                            disabled={selectionFlag === SelectionFlagEnum.NEW_PROTOCOL}
                            customerId={sessionState.selected.customerId!}
                            objectId="16"
                            type="departure"
                            placeholder="Seleziona protocollo..."
                            value={newMeasureState.newMeasureCreationRequest.departureProtocolId}
                            onChange={(value) => dispatch(setNewMeasureCreationDepartureProtocolId(value))}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}